import { render, staticRenderFns } from "./starfield.svg.vue?vue&type=template&id=2b9f3ed6&scoped=true&"
import script from "./starfield.svg.vue?vue&type=script&lang=js&"
export * from "./starfield.svg.vue?vue&type=script&lang=js&"
import style0 from "./starfield.svg.vue?vue&type=style&index=0&id=2b9f3ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f3ed6",
  null
  
)

export default component.exports